module.exports = __webpack_public_path__ + "img/iconos-06.a549f4d4.png";